import { MultiSelectOption } from '../types';

export const filterOptions = (
  options: MultiSelectOption[],
  searchText: string
): MultiSelectOption[] => {
  return options.filter((option) => option.label.toLowerCase().includes(searchText.toLowerCase()));
};

export const formatSelectedValues = (
  selected: string[],
  options: MultiSelectOption[],
  placeholder?: string
): string => {
  if (selected.length === 0) return placeholder || '';
  return options
    .filter((option) => selected.includes(option.value))
    .map((option) => option.label)
    .join(', ');
};

export const handleClickOutside = (event: React.SyntheticEvent<Element, Event>): boolean => {
  if (event.type === 'mousedown') {
    const target = event.target as HTMLElement;
    const isOutsideMenu = !target.closest('.MuiMenu-paper');
    const isOutsideSelect = !target.closest('.select-wrapper');
    return isOutsideMenu && isOutsideSelect;
  }
  return false;
};
